<template>
  <div class="PageMyReleaseOrder">
    <h2 class="includeBtn">{{ $t("pages.wording.myReleaseOrder") }}</h2>
    <!--我的放行單-->
    <div class="releaseOrderTopBox">
      <div class="releaseOrder releaseOrderTopText">
        {{ $t("pages.wording.releaseNo") }}:{{ ruleForm.releaseOrderNo }}
      </div>
      <!--releaseOrder-->
      <div class="releaseOrderTopText">
        {{ $t("pages.wording.reserve") }}:
        <a class="reserveOrderTitle" @click="goReservePage">{{ ruleForm.reserveNo }}</a>
      </div>
      <!--reserveOrder-->
      <div class="Btn-Bottom-Content">
        <div class="Btn-Content">
          <el-button class="button-right" @click="goBack" type="success">{{ $t("pages.button.close") }}</el-button
          ><!--關閉-->
        </div>
      </div>
    </div>
    <el-collapse v-model="activeShowBlock">
      <el-form ref="ruleForm" :model="ruleForm" label-width="120px">
        <el-collapse-item class="collapsecontent" name="basic">
          <template slot="title">
            <h3>{{ $t("pages.wording.basisInfo") }}</h3>
            <!--基本資訊-->
          </template>
          <div class="boxContain c-form">
            <!--查詢放行單-->
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.applicatorName')" prop="applicatorName"
                  ><!--填單人-->
                  <el-input
                    :disabled="true"
                    :value="ruleForm.applicatorName"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.deltaContactName')" prop="deltaContactName"
                  ><!--台達接洽人-->
                  <el-input
                    :disabled="true"
                    :value="ruleForm.deltaContactName"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.deltaContactNumber')" prop="deltaContactNumber"
                  ><!--接洽人電話-->
                  <el-input
                    :disabled="true"
                    :value="ruleForm.deltaContactNumber"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.deltaContactMail')" prop="deltaContactMail"
                  ><!--接洽人Mail-->
                  <el-input
                    :disabled="true"
                    :value="ruleForm.deltaContactMail"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!--boxContain-->
        </el-collapse-item>
        <el-collapse-item class="collapsecontent" name="detail">
          <template slot="title">
            <h3>{{ $t("pages.wording.detailInfo") }}</h3>
            <!--詳細資訊-->
          </template>
          <div class="boxContain c-form">
            <!--查詢放行單-->
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="OA Code" prop="oaCode"
                  ><!--OA Code-->
                  <el-input
                    :disabled="true"
                    :value="ruleForm.oaCode"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.vendor')" prop="vendor"
                  ><!--公司名稱-->
                  <el-input
                    :disabled="true"
                    :value="ruleForm.vendor"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveArriveDate')" prop="reserveArriveDate"
                  ><!--預約抵達日期-->
                  <el-input
                    :disabled="true"
                    :value="ruleForm.reserveArriveDate"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveArriveTime')" prop="reserveArriveTime"
                  ><!--預約抵達時間-->
                  <el-input
                    :disabled="true"
                    :value="ruleForm.reserveArriveTime"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.carPlat')" prop="carPlat"
                  ><!--車輛號牌-->
                  <el-input
                    :disabled="true"
                    :value="ruleForm.carPlat"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.salesDate')" prop="saleDate"
                  ><!--出售日期-->
                  <el-input
                    :disabled="true"
                    :value="ruleForm.saleDate"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveFactory')" prop="reserveFactory"
                  ><!--抵達廠別-->
                  <el-input
                    :disabled="true"
                    :value="ruleForm.reserveFactory"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.reserveLocation')" prop="reserveLocation"
                  ><!--抵達地點-->
                  <el-input
                    :disabled="true"
                    :value="$store.getters.getSysCodeText('location', ruleForm.reserveLocation)"
                    :placeholder="$t('pages.wording.placeholderNodata')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.emptyCar')" prop="emptyCarWeight"
                  ><!--空車重量-->
                  <el-input
                    :disabled="true"
                    type="number"
                    :value="ruleForm.emptyCarWeight"
                    :placeholder="$t('pages.wording.placeholderInput')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('pages.wording.scaleLocation')" prop="scaleLocation"
                  ><!--過磅地點-->
                  <el-input
                    :disabled="true"
                    :value="$store.getters.getSysCodeText('scaleLocation', ruleForm.scaleLocation)"
                    :placeholder="$t('pages.wording.placeholderInput')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!--boxContain-->
        </el-collapse-item>
      </el-form>
      <el-form ref="soRuleForm" :model="soRuleForm" label-width="0px">
        <el-collapse-item class="collapsecontent" name="materialDetial">
          <template slot="title">
            <h3>{{ $t("pages.wording.materialDetial") }}</h3>
            <!--廢料明細資訊-->
          </template>
          <div class="boxContain c-table includeBtn">
            <el-tabs v-model="activeName">
              <el-tab-pane label="preProcess" name="first">
                <span slot="label"><i class="el-icon-takeaway-box"></i>{{ $t("pages.wording.materialInfo") }}</span
                ><!--廢料明細-->
                <div class="s-table">
                  <template>
                    <el-table :data="soRuleForm.soList" class="soList" border style="width: 100%" height="450px">
                      <el-table-column prop="SO" label="SO" width="110"></el-table-column
                      ><!--SO--><!--so-->
                      <el-table-column prop="SOLine" label="SO LINE" width="80"></el-table-column
                      ><!--SO LINE--><!--soLine-->
                      <el-table-column prop="partNo" :label="$t('pages.wording.partNo')" width="150"></el-table-column
                      ><!--廢料料號--><!--partNo-->
                      <el-table-column prop="partNameCN" :label="$t('pages.wording.partName')"></el-table-column
                      ><!--廢料名稱--><!--partName-->
                      <el-table-column :label="$t('pages.wording.grossWeight')" width="120">
                        <template slot-scope="scope">
                          <el-form-item :prop="'soList.' + scope.$index + '.grossWeight'">
                            {{ scope.row.grossWeight }}
                          </el-form-item>
                        </template> </el-table-column
                      ><!--毛重--><!--grossWeight-->
                      <el-table-column :label="$t('pages.wording.packType')" width="220">
                        <template slot-scope="scope">
                          <el-form-item :prop="'soList.' + scope.$index + '.packType'">
                            {{ $store.getters.getSysCodeText("packType", scope.row.packType) }}
                          </el-form-item>
                        </template> </el-table-column
                      ><!--包裝種類--><!--packType-->
                      <el-table-column :label="$t('pages.wording.packNumber')" width="140">
                        <template slot-scope="scope">
                          <el-form-item :prop="'soList.' + scope.$index + '.packNumber'">
                            {{ scope.row.packNumber }}
                          </el-form-item>
                        </template> </el-table-column
                      ><!--包裝數量--><!--packNumber-->
                      <el-table-column :label="$t('pages.wording.packWeight')" width="120">
                        <template slot-scope="scope">
                          <el-form-item :prop="'soList.' + scope.$index + '.packWeight'">
                            {{ scope.row.packWeight }}
                          </el-form-item>
                        </template> </el-table-column
                      ><!--總皮重--><!--packWeight-->
                      <el-table-column prop="netWeight" :label="$t('pages.wording.netWeight')" width="120">
                      </el-table-column
                      ><!--淨重--><!--netWeight-->
                      <el-table-column prop="unit" :label="$t('pages.wording.unit')" width="120"></el-table-column
                      ><!--單位--><!--unit-->
                      <el-table-column prop="plantCode" label="Plant Code" width="120"></el-table-column
                      ><!--PlantCode--><!--plantCode-->
                      <el-table-column prop="storageLogic" label="Storage Loc." width="120"></el-table-column
                      ><!--PlantCode--><!--storageLogic-->
                    </el-table>
                  </template>
                </div>
                <!--s-table--> </el-tab-pane
              ><!--preProcess-->
            </el-tabs>
          </div>
          <!--boxContain-->
        </el-collapse-item>
      </el-form>
    </el-collapse>
    <el-dialog :title="$t('pages.wording.soStatus')" :visible.sync="dialog.soCredit.showDialog" width="50%">
      <el-table
        class="dialogSoCredit"
        :data="soRuleForm.soList"
        border
        style="width: 90%"
        height="300px"
        :default-sort="{ prop: 'so', order: 'descending' }"
      >
        <el-table-column prop="SO" label="SO" width=""> </el-table-column
        ><!--SO-->
        <el-table-column prop="SOLine" label="SO ITEM" width="100"> </el-table-column
        ><!--SOLINE-->
        <el-table-column prop="creditStatus" :label="$t('pages.wording.creditStatus')" width="120"> </el-table-column
        ><!--單據信用狀態-->
      </el-table>
      <div id="creditText">{{ $t("pages.wording.creditStatus") }}: P(Open)、R(Release)</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialog.soCredit.showDialog = false">{{
          $t("pages.button.confirm")
        }}</el-button
        ><!--確定-->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { api } from "@/utils/api.js"
import { utils } from "@/utils/utils.js"
export default {
  name: "PageVendorReleaseOrderInfo",
  props: ["id", "prvPageInfo"],
  components: {},
  data() {
    return {
      activeName: "first",
      submitData: {},
      releaseData: {},
      reserveData: {},
      soList: [],
      signTable: [],
      applicator: {
        name: "",
        number: "",
        deptName: "",
        area: "",
        deptCode: "",
      },
      dialog: {
        soCredit: {
          showDialog: false,
        },
      },
      ruleForm: {
        releaseOrderNo: "",
        reserveNo: "",
        applicatorName: "",
        applicatorNT: "",
        deltaContactName: "", //台達接洽人
        deltaContactNumber: "", //台達接洽人電話
        deltaContactMail: "", //台達接洽人Mail
        oaCode: "",
        vendor: "", //廠商名稱
        reserveArriveDate: "", //進廠日期
        reserveArriveTime: "", //進廠時間
        carPlat: "", //車牌
        saleDate: "", //出售日期
        reserveFactory: "", //抵達廠別
        reserveLocation: "", //抵達地點
        emptyCarWeight: "", //空車重量
        scaleLocation: "", //過磅地點
        soCreditStatus: false,
        reserveStatus: "",
      },
      soRuleForm: {
        soList: [],
      },
      activeShowBlock: ["basic", "detail", "materialDetial", "signDetail"],
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const releaseID = this.$props.id === undefined ? this.$route.query.id : this.$props.id
      this.getReleaseInfo(releaseID)
    },
    async getReleaseInfo(releaseID) {
      try {
        const vueInstance = this
        const { data } = await api.apiGetReleaseInfo(releaseID)
        const releaseInfo = data
        vueInstance.submitData = {
          releaseData: releaseInfo.releseData,
          soList: releaseInfo.soList,
        }
        vueInstance.releaseData = releaseInfo.releseData
        vueInstance.reserveData = releaseInfo.reserveData
        vueInstance.soList = releaseInfo.soList

        vueInstance.buildReleaseInfo(vueInstance.releaseData)
        vueInstance.buildReserveInfo(vueInstance.reserveData)
        vueInstance.buildSoListInfo(vueInstance.soList)
      } catch {}
    },
    buildReleaseInfo(data) {
      this.ruleForm.saleDate = data.saleDate
      this.ruleForm.emptyCarWeight = data.emptyCarWeight
      this.ruleForm.scaleLocation = data.scaleLocation
      this.ruleForm.releaseOrderNo = data.releaseOrderNo
    },
    buildReserveInfo(data) {
      this.ruleForm.reserveNo = data.reserveNo
      this.ruleForm.applicatorName = data.applicatorName
      this.ruleForm.applicatorNT = data.applicatorNT
      this.ruleForm.deltaContactName = data.deltaContactName
      this.ruleForm.deltaContactNumber = data.deltaContactNumber
      this.ruleForm.deltaContactMail = data.deltaContactMail
      this.ruleForm.oaCode = data.OACode
      this.ruleForm.vendor = data.vendor
      this.ruleForm.reserveStatus = data.reserveStatus
      this.ruleForm.reserveArriveDate = utils.getFormateDateTime("Date", data.reserveArriveDatetime)
      this.ruleForm.reserveArriveTime = utils.getFormateDateTime("Time", data.reserveArriveDatetime)
      if (data.tempCar) this.ruleForm.carPlat = data.tmpCarPlat
      else this.ruleForm.carPlat = data.carPlat
      this.ruleForm.reserveFactory = data.reserveFactory
      this.ruleForm.reserveLocation = data.reserveLocation
    },
    buildSoListInfo(datas) {
      this.soRuleForm.soList = datas
    },
    goReservePage() {
      let goReservePage = ""
      if (this.ruleForm.reserveStatus == "vendorComfirm") {
        goReservePage = "PageMyReservationForm"
      } else {
        goReservePage = "PageMyReservationInfo"
      }
      this.$router.push({
        name: goReservePage,
        query: { id: this.reserveData.id },
      })
    },
    goBack() {
      if (
        this.$route.params.prevPageParams !== undefined &&
        this.$route.params.prevPageParams.routeName !== undefined
      ) {
        switch (this.$route.params.prevPageParams.routeName) {
          case "PageVendorReleaseOrder":
          case "PageSearchVendorReleaseOrder":
            this.setQueryParamsToStorage()
            break
        }
      }
      this.$router.push({
        name:
          this.$route.params.prevPageParams === undefined
            ? "PageVendorReleaseOrder"
            : this.$route.params.prevPageParams.routeName,
      })
    },
    setQueryParamsToStorage() {
      window.sessionStorage.setItem("queryParams", JSON.stringify(this.$route.params.queryParams))
    },
  },
  watch: {},
}
</script>

<style>
.releaseOrderTopBox {
  position: relative;
  margin-bottom: 15px;
}
.releaseOrderTopBox .releaseOrderTopText {
  display: inline-block;
  font-size: 1.8rem;
  width: 50%;
}

.soList .el-form-item__content input {
  width: 100%;
  height: 30px;
}
.soList .el-form-item {
  margin-bottom: 0px;
}
.reserveOrderTitle {
  color: #007bff !important;
  cursor: pointer;
}
.reserveOrderTitle:hover {
  text-decoration: underline !important;
}
#app .dialogSoCredit {
  margin: 0px auto;
  border: 1px #ccc solid;
}
#app .dialogSoCredit th {
  background-color: #f5f5f5;
  font-weight: bolder;
}
#creditText {
  width: 90%;
  margin: 10px auto;
}
.soList table .is-error .el-input {
  margin-bottom: 12px;
}
.soList table .is-error .el-form-item__error {
  top: 70%;
}
#PDFDownloadContainer {
  height: 1px;
  position: absolute;
  overflow: hidden;
}
#PDFDownload {
  position: absolute;
  width: 1240px;
  height: 1754px;
  font-size: 18px;
}
#PDFDownloadContent {
  margin: 50px;
}
#pdf-title {
  width: 100%;
  text-align: center;
  margin: 10px auto;
  border-bottom: 1px #000 solid;
}
#PDFDownload .el-row {
  margin: 10px 0px;
}
#PDFDownload .pdf-box {
  padding-bottom: 30px;
  border-bottom: 1px #000 solid;
}
</style>
<style scoped>
.Btn-Bottom-Content {
  position: fixed !important;
  background: rgb(22, 22, 21) !important;
  background: linear-gradient(
    0deg,
    rgba(22, 22, 21, 0.7931547619047619) 26%,
    rgba(255, 255, 255, 0.03125) 96%
  ) !important;
  z-index: 5 !important;
  height: 100px !important;
  bottom: 0px !important;
  left: 0px !important;
  right: 0px !important;
  overflow: hidden !important;
}
.Btn-Content {
  width: 93%;
}
.button-right {
  margin-left: 10px !important;
  margin-top: 5px !important;
}
.button-last {
  margin-left: 10px !important;
}
@media (max-width: 1025px) {
  .Btn-Bottom-Content {
    left: 0px !important;
  }
}
@media (min-width: 1026px) {
  .menuOpen .Btn-Bottom-Content {
    left: 299px !important;
  }
}
</style>
